import { ShieldCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { PARTNERS } from "@/data/site";

const PartnerCard = ({ p, i }) => (
  <Reveal delay={i * 0.05}>
    <div
      data-testid={`partner-card-${i}`}
      className="group flex h-full flex-col items-center rounded-3xl border border-brand/10 bg-white p-6 text-center transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-2xl hover:shadow-gold/10"
    >
      <div className="flex h-24 w-full items-center justify-center">
        {p.logo ? (
          <img
            src={p.logo}
            alt={p.name}
            loading="lazy"
            className="max-h-20 max-w-[85%] object-contain transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <span className="font-display flex h-20 items-center justify-center rounded-2xl bg-gold px-6 text-2xl font-extrabold tracking-wider text-white">
            {p.name.split(" ")[0].toUpperCase()}
          </span>
        )}
      </div>
      <p className="font-display mt-5 text-base font-bold leading-snug text-forest">{p.name}</p>
      {p.full && (
        <p className="mt-1 text-xs italic leading-snug text-brand-hover">{p.full}</p>
      )}
      <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-mint px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-brand">
        <ShieldCheck className="h-3 w-3" />
        Partenaire agréé
      </span>
    </div>
  </Reveal>
);

const PartnersGrid = () => {
  const { t } = useLanguage();
  const groups = [
    { key: "assurance", label: t.partners.groupAssurance },
    { key: "expertise", label: t.partners.groupExpertise },
  ];
  return (
    <div className="mt-14 space-y-14" data-testid="partners-grid">
      {groups.map((g) => (
        <div key={g.key}>
          <Reveal>
            <div className="mb-6 flex items-center gap-4">
              <h3 className="font-display text-lg font-bold text-forest sm:text-xl">{g.label}</h3>
              <span className="h-px flex-1 bg-gradient-to-r from-gold/60 to-transparent" />
            </div>
          </Reveal>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
            {PARTNERS.filter((p) => p.type === g.key).map((p, i) => (
              <PartnerCard key={p.name} p={p} i={i} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PartnersGrid;
